<script>
import logo from '@/assets/images/polysigma-logo-dark.png'

export default {
    name: 'AppFooter',
    data() {
        return {
            logo,
            year: new Date().getFullYear(),
        }
    },
}
</script>

<template>
    <footer class="ps-footer">
        <b-container class="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
            <b-img :src="logo" alt="PolySigma" class="ps-footer__logo mb-3 mb-md-0" />
            <b-nav class="ps-footer__nav mb-3 mb-md-0">
                <b-nav-item :to="{ name: 'home', hash: '#methods' }">Methods</b-nav-item>
                <b-nav-item :to="{ name: 'home', hash: '#integration' }">Integration</b-nav-item>
                <b-nav-item :to="{ name: 'home', hash: '#beta' }">Request beta access</b-nav-item>
            </b-nav>
            <p class="small text-muted mb-0">© {{ year }} Narrow Labs, LLC.</p>
        </b-container>
    </footer>
</template>

<style scoped lang="scss">
.ps-footer {
    border-top: 1px solid var(--ps-rule);
    padding: 2.5rem 0 calc(2.5rem + env(safe-area-inset-bottom));
}

.ps-footer__logo {
    height: 1.5rem;
    width: auto;
    align-self: flex-start;
}

@media (min-width: 768px) {
    .ps-footer__logo {
        align-self: center;
    }
}

.ps-footer__nav ::v-deep .nav-link {
    color: var(--ps-haze);
    padding-left: 0;
    padding-right: 1.25rem;
}

.ps-footer__nav ::v-deep .nav-link:hover {
    color: var(--ps-frost);
}
</style>
